import React, { useState, useEffect } from 'react'
import { useNavigate, Link, useLocation, useSearchParams } from 'react-router-dom'
import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Table } from "antd";
import { getJobOrderListCC } from '../../../../../../Redux/action/CustomClearance/CCAction';
import { BeatLoader } from 'react-spinners';
// import Pagination from '../../Pagination';
import Skeleton from 'react-loading-skeleton'
import { Tooltip } from 'antd';
import ReactPaginate from 'react-paginate';
import { adminMainUrl } from '../../../../../../Config';
// import AddMaster from "./AddMaster";
// import EditMaster from "./EditMaster";
// import { adminMainUrl } from '../../../../Config';
// import { DesignationApi } from '../../../../Redux/action/MasterAction';

const ExportJobList = ({ accessedModules, accessedPermission }) => {
    const navigate = useNavigate();
    const [currentData, setCurrentData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [dataOffset, setDataOffset] = useState(0);
    const dataPerPage = 10;
    const [reload, setReload] = useState(false);
    const [spinnerLoader, setSpinnerLoader] = useState(false)
    const [DesignationName, setDesignationName] = useState(null)
    const [DesignationId, setDesignationId] = useState(null)
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // Number of items per page
    // const { name } = useParams();
    const dispatch = useDispatch();
    let user_id = Cookies.get('flexichain_user_id');
    const token = Cookies.get("token");
    const queryParams = new URLSearchParams();
    const queryString = new URLSearchParams().toString();


    const location = useLocation();
    const [searchParams] = useSearchParams();
    const page = searchParams.get("page") || 1;
    const [dataSource, setDataSource] = useState(false);
    const [pageLoader, setPageLoader] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [totalItems, setTotalItems] = useState(0);
    const {
        loadingDesignationTypeApi,
        findDesignationTypeData,
        findDesignationTypeDataError,
    } = useSelector(state => state?.MasterReducer);

    const handleSuccess = () => {
        // Toggle reload to trigger useEffect
        setReload(prev => !prev);
    };

    useEffect(() => {
        console.log(page, "page")
        if (user_id) {
            dispatch(getJobOrderListCC(token, user_id, page, queryString));
        }
    }, [user_id, page]);

    let {
        loadingJobOrderListCC,
        jobOrderListCCData,
        jobOrderListCCCurrentPage,
        jobOrderListCCTotalPage,
        jobOrderListCCTotalData,
        jobOrderListCCStatusCount,

    } = useSelector(state => state?.CCReducer);



    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = findDesignationTypeData?.data


    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const onSelectChange = newSelectedRowKeys => {
        setSelectedRowKeys(newSelectedRowKeys)
    }


    const [editshow, setEditShow] = useState(false);
    const handleEditClose = () => setEditShow(false);
    const handleEditShow = () => setEditShow(true);
    const columns = [
        { title: "S. No.", dataIndex: "sNo", key: "sNo" },
        { title: "Job Date", dataIndex: "jobDate", key: "jobDate" },
        { title: "Job No", dataIndex: "jobNo", key: "jobNo" },
        // { title: "Job Date", dataIndex: "jobDate", key: "jobDate" },
        { title: "Filing Mode Type", dataIndex: "filingModeType", key: "filingModeType" },
        { title: "Filing Mode Name", dataIndex: "filingModeName", key: "filingModeName" },
        { title: "Transport Mode", dataIndex: "transportMode", key: "transportMode" },
        { title: "Custom House", dataIndex: "customHouseId", key: "Custom House Id" },
        // { title: "Job Owner Id", dataIndex: "jobOwnerId", key: "jobOwnerId" },
        { title: "Loading Port", dataIndex: "loadingPortId", key: "loadingPortId" },
        { title: "SB Type", dataIndex: "sbType", key: "sbType" },
        { title: "Consignment Type", dataIndex: "consignmentType", key: "consignmentType" },
        // { title: "Current Status", dataIndex: "currentStatus", key: "currentStatus" },
        // { title: "Admin Id", dataIndex: "adminId", key: "adminId" },
        // { title: "Created By", dataIndex: "createdBy", key: "createdBy" },
        // { title: "Created At", dataIndex: "createdAt", key: "createdAt" },
        // { title: "Updated At", dataIndex: "updatedAt", key: "updatedAt" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];



    useEffect(() => {

        if (loadingJobOrderListCC) {
            setPageLoader(true);
        } else {
            setPageLoader(false);
        };
        // console.log("============>", jobOrderListCCData);

        if (jobOrderListCCData) {
            let arr = jobOrderListCCData?.map((value, i) => ({
                key: i + 1,
                sNo: i + 1,
                jobDate: value?.job_date,
                jobNo: value?.job_number,
                // jobDate: value?.job_date,
                filingModeType: value?.filing_mode_type,
                filingModeName: value?.filing_mode_name,
                transportMode: value?.transport_mode,
                customHouseId: value?.custom_house_exp ? value?.custom_house_exp?.name : "-",
                // jobOwnerId: value?.job_owner_id,
                loadingPortId: value?.port_name_exp ? `${value.port_name_exp?.name} (${value.port_name_exp?.code})` : "-",
                sbType: value?.s_b_type,
                consignmentType: value?.consignment_type,
                // currentStatus: value?.current_status,
                // adminId: value?.admin_id,
                // createdBy: value?.created_by,
                // createdAt: value?.createdAt,
                // updatedAt: value?.updatedAt,

                action: (
                    <>
                        <div className="d-flex">
                            <div className="dropdown table-action">
                                <Link to="#" className="action-icon" data-bs-toggle="dropdown" >
                                    <i className="fa fa-ellipsis-v"></i>
                                </Link>
                                <div className="dropdown-menu dropdown-menu-right">
                                    <div className="dropdown-item" onClick={() => {
                                        navigate(`/flexichain/custom-clearance/export-job/edit/${btoa(value?.id)}`)
                                    }}>
                                        <i className="ti ti-pencil text-blue-light"></i> Edit
                                    </div>
                                </div>
                            </div>
                        </div>

                    </>
                ),
            }));
            setDataSource(arr);
        }

        if (jobOrderListCCTotalData) {
            setTotalItems(jobOrderListCCTotalData);
        }

        if (jobOrderListCCTotalPage) {
            setTotalPages(jobOrderListCCTotalPage)
        }
    }, [jobOrderListCCData, loadingJobOrderListCC, jobOrderListCCCurrentPage, jobOrderListCCTotalPage, jobOrderListCCTotalData, jobOrderListCCStatusCount]);


    const handlePageClick = (selectedObject) => {
        const selectedPage = selectedObject.selected + 1;
        const params = new URLSearchParams(location.search);
        setCurrentPage(selectedPage);
        params.set("page", selectedPage);
        navigate(`?${params.toString()}`);
    };

    // const dataSource = [{
    //     key: "1", 
    //     SNo: "1", 

    //     Status:
    //         <>
    //             <span
    //                 className={`cursor-pointer  badge badge-pill badge-status bg-success   `}>Active</span>
    //         </>
    //     ,
    //     action: (
    //         <div className="dropdown table-action">
    //             <Link to="#" className="action-icon" data-bs-toggle="dropdown">
    //                 <i className="fa fa-ellipsis-v"></i>
    //             </Link>
    //             <div className="dropdown-menu dropdown-menu-right">
    //                 <div className="dropdown-item cursor-pointer" onClick={handleEditShow}>
    //                     <i className="ti ti-edit text-blue me-2"></i> Edit
    //                 </div>
    //             </div>
    //         </div>
    //     )
    // },
    // {
    //     key: "2", 
    //     SNo: "2", 
    //     Status:
    //         <>
    //             <span
    //                 className={`cursor-pointer  badge badge-pill badge-status bg-danger   `}>Inactive</span>
    //         </>
    //     ,
    //     action: (
    //         <div className="dropdown table-action">
    //             <Link to="#" className="action-icon" data-bs-toggle="dropdown">
    //                 <i className="fa fa-ellipsis-v"></i>
    //             </Link>
    //             <div className="dropdown-menu dropdown-menu-right">
    //                 <div className="dropdown-item cursor-pointer" onClick={handleEditShow}>
    //                     <i className="ti ti-edit text-blue me-2"></i> Edit
    //                 </div>

    //             </div>
    //         </div>
    //     )
    // },

    // {
    //     key: "3", 
    //     SNo: "3", 

    //     Status:
    //         <>
    //             <span
    //                 className={`cursor-pointer  badge badge-pill badge-status bg-success   `}>Active</span>


    //         </>
    //     ,
    //     action: (
    //         <div className="dropdown table-action">
    //             <Link to="#" className="action-icon" data-bs-toggle="dropdown">
    //                 <i className="fa fa-ellipsis-v"></i>
    //             </Link>
    //             <div className="dropdown-menu dropdown-menu-right">
    //                 <div className="dropdown-item cursor-pointer" onClick={handleEditShow}>
    //                     <i className="ti ti-edit text-blue me-2"></i> Edit
    //                 </div>

    //             </div>
    //         </div>
    //     )
    // },]
    const [addShow, setAddShow] = useState(false);
    const handleAddClose = () => setAddShow(false);
    const handleAddShow = () => setAddShow(true);


    return (
        <>
            <div className="page-wrapper">
                <div className="content">
                    <div className="row">
                        <div className="col-md-12">
                            {/* Page Header */}
                            <div className="page-header">
                                <div className="row align-items-center">
                                    <div className="col-8">
                                        <h4 className="page-title">
                                            Export Job<span className="count-title">{jobOrderListCCTotalData ?? 0}</span>
                                        </h4>
                                    </div>
                                    <div className="col-4 text-end">
                                        <div className="head-icons">
                                            <a
                                                href="javascript:void(0);"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                data-bs-original-title="Collapse"
                                                id="collapse-header"
                                            >
                                                <i className="ti ti-chevrons-up" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* /Page Header */}
                        </div>
                    </div>
                    <div className="card">

                        <div className="card-body">

                            {/* Filter */}
                            <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-1">
                                <div className="d-flex align-items-center flex-wrap row-gap-2">
                                    {/* <div className="dropdown me-2">
                                        <a
                                            href="javascript:void(0);"
                                            className="dropdown-toggle"
                                            data-bs-toggle="dropdown"
                                        >
                                            <i className="ti ti-sort-ascending-2 me-2" />
                                            Sort{" "}
                                        </a>

                                        <div className="dropdown-menu  dropdown-menu-start">
                                            <ul>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Ascending
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Descending
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Recently Viewed
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Recently Added
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div> */}
                                    {/* <div className="icon-form mb-3 mb-sm-0">
                                        <span className="form-icon">
                                            <i className="ti ti-search" />
                                        </span>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            placeholder="Search "
                                            name='search_by'
                                        // value={searchText}
                                        // onChange={(e) => setSearchText(e.target.value)}
                                        />
                                    </div> */}
                                    <div className="form-sorts dropdown ms-2">
                                        {/* <Tooltip placement="top" title="Filter">
                                            <a
                                                href="javascript:void(0);"
                                                data-bs-toggle="dropdown"
                                                data-bs-auto-close="outside"
                                                style={{
                                                    paddingTop: "7px",
                                                    paddingBottom: "6px"
                                                }}
                                            >
                                                <i className="ti ti-filter-share me-0" />
                                            </a>
                                        </Tooltip> */}
                                        {/* <div className="filter-dropdown-menu dropdown-menu  dropdown-menu-md-end p-3">
                                            <div className="filter-set-view">
                                                <table className="content-table">
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">Type</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                <select
                                                                    className='form-control form-control-sm ms-2'
                                                                >
                                                                    <option value="ALL">All</option>
                                                                    <option value="1">Air Export Job order</option>
                                                                    <option value="2">Air Import Job order</option>
                                                                    <option value="1">Sea Export Job order</option>
                                                                    <option value="2">Sea Import Job order</option>
                                                                    <option value="1">Road Export Job order</option>
                                                                    <option value="2">Road Import Job order</option>
                                                                    <option value="1">Rail Export Job order</option>
                                                                    <option value="2">Rail Import Job order</option>
                                                                    <option value="2">General</option>
                                                                </select>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">Shipment Type</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                {" "}
                                                                <select
                                                                    className='form-control form-control-sm ms-2'
                                                                >
                                                                    <option value="ALL">All</option>
                                                                    <option value="1">International</option>
                                                                    <option value="2">Domestic</option>
                                                                </select>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">Active</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                {" "}
                                                                <select
                                                                    className='form-control form-control-sm ms-2'
                                                                >
                                                                    <option value="YES">YES</option>
                                                                    <option value="NO">NO</option>
                                                                </select>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">Job Order No.</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                {" "}
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm ms-2"
                                                                    placeholder="Enter Prefix"
                                                                    name="email"
                                                                // value={formik.values.email}
                                                                // onChange={formik.handleChange}
                                                                // onBlur={formik.handleBlur}
                                                                // value={email}
                                                                // onChange={(e) => setEmail(e.target.value)}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">Job Order Date</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                {" "}
                                                                <input
                                                                    type="date"
                                                                    className="form-control form-control-sm ms-2"
                                                                    placeholder="Enter CheckDigit"
                                                                    name="phone"
                                                                // value={formik.values.phone}
                                                                // onChange={formik.handleChange}
                                                                // onBlur={formik.handleBlur}
                                                                // value={mobileNumber}
                                                                // onChange={(e) => setMobileNumber(e.target.value)}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">Shipper</label>
                                                            </td>
                                                            <td className="input_box_filter">

                                                                <select
                                                                    className='form-control form-control-sm ms-2'
                                                                >
                                                                    <option value="ALL">All</option>
                                                                    <option value="1">Ravi</option>
                                                                    <option value="2">Sakshi</option>
                                                                    <option value="1">Abhishek</option>
                                                                    <option value="2">Durga</option>
                                                                    <option value="1">Shweta</option>
                                                                </select>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">Consignee</label>
                                                            </td>
                                                            <td className="input_box_filter">

                                                                <select
                                                                    className='form-control form-control-sm ms-2'
                                                                >
                                                                    <option value="ALL">All</option>
                                                                    <option value="1">Ravi</option>
                                                                    <option value="2">Sakshi</option>
                                                                    <option value="1">Abhishek</option>
                                                                    <option value="2">Durga</option>
                                                                    <option value="1">Shweta</option>
                                                                </select>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">Loading Port</label>
                                                            </td>
                                                            <td className="input_box_filter">

                                                                <select
                                                                    className='form-control form-control-sm ms-2'
                                                                >
                                                                    <option value="">Select Port</option>
                                                                    <option value="1">Mumbai</option>
                                                                    <option value="2">Delhi</option>
                                                                    <option value="1">Kolkata</option>
                                                                    <option value="2">Pune</option>
                                                                </select>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">Discharge Port</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                            <select
                                                                    className='form-control form-control-sm ms-2'
                                                                >
                                                                    <option value="">Select Port</option>
                                                                    <option value="1">Mumbai</option>
                                                                    <option value="2">Delhi</option>
                                                                    <option value="1">Kolkata</option>
                                                                    <option value="2">Pune</option>
                                                                </select>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <div className="filter-reset-btns">
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <a className="btn btn-light">
                                                                Reset
                                                            </a>
                                                        </div>
                                                        <div className="col-6">
                                                            <button type='submit' className="btn btn-primary w-100">
                                                                Filter
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}
                                    </div>
                                    {/* <div className="icon-form">
                                        <span className="form-icon">
                                            <i className="ti ti-calendar" />
                                        </span>
                                        <input
                                            type="text"
                                            className="form-control bookingrange"
                                            placeholder=""
                                        />
                                    </div> */}
                                </div>
                                <div className="d-flex align-items-center flex-wrap row-gap-2">
                                    {/* <Tooltip placement="top" title="Print Data">
                                        <div
                                            className="btn btn-primary cursor-pointer me-2"
                                        >
                                            <i className="ti ti-printer text-white"></i>
                                        </div>
                                    </Tooltip>
                                    <Tooltip placement="top" title="Export Data">
                                        <div
                                            className="btn btn-primary cursor-pointer me-2"
                                        >
                                            <i className="fas fa-file-export text-white"></i>
                                         </div>
                                    </Tooltip> */}
                                    {/* <button type='submit' className="btn btn-primary me-2">
                                        Search
                                    </button>
                                    <a
                                        className='btn btn-light me-2'
                                    >
                                        Clear
                                    </a> */}
                                    <div
                                        className="btn btn-primary cursor-pointer me-2"
                                        // onClick={handleAddShow}
                                        onClick={() => { navigate("/flexichain/custom-clearance/export-job/add") }}
                                    >
                                        <i className="ti ti-square-rounded-plus me-2" />
                                        Add Export Job
                                    </div>

                                    {/* <div className="dropdown me-2">
                                        <a
                                            href="javascript:void(0);"
                                            className="btn bg-soft-purple text-purple"
                                            data-bs-toggle="dropdown"
                                            data-bs-auto-close="outside"
                                        >
                                            <i className="ti ti-columns-3 me-2" />
                                            Manage Columns
                                        </a>
                                        <div className="dropdown-menu  dropdown-menu-md-end dropdown-md p-3">
                                            <h4 className="mb-2 fw-semibold">Want to manage datatables?</h4>
                                            <p className="mb-3">
                                                Please drag and drop your column to reorder your table and
                                                enable see option as you want.
                                            </p>
                                            <div className="border-top pt-3">
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Name
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-name" className="check" />
                                                        <label htmlFor="col-name" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Phone
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-phone" className="check" />
                                                        <label htmlFor="col-phone" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Email
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-email" className="check" />
                                                        <label htmlFor="col-email" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Tags
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-tag" className="check" />
                                                        <label htmlFor="col-tag" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Location
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-loc" className="check" />
                                                        <label htmlFor="col-loc" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Rating
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-rate" className="check" />
                                                        <label htmlFor="col-rate" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Owner
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-owner" className="check" />
                                                        <label htmlFor="col-owner" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Contact
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input
                                                            type="checkbox"
                                                            id="col-contact"
                                                            className="check"
                                                            defaultChecked=""
                                                        />
                                                        <label htmlFor="col-contact" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Status
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input
                                                            type="checkbox"
                                                            id="col-status"
                                                            className="check"
                                                        />
                                                        <label htmlFor="col-status" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Action
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input
                                                            type="checkbox"
                                                            id="col-action"
                                                            className="check"
                                                        />
                                                        <label htmlFor="col-action" className="checktoggle" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}

                                    {/* <div className="view-icons">
                                        <Link onClick={() => { setGrid(true) }} className={`${grid === true && "active"}`}>
                                            <i className="ti ti-list-tree" />
                                        </Link>
                                        <Link onClick={() => { setGrid(false) }} className={`${grid === false && "active"}`}>
                                            <i className="ti ti-grid-dots" />
                                        </Link>
                                    </div> */}
                                </div>
                            </div>
                            {/* /Filter */}
                            {/* Contact List */}

                            {/* {
                                loadingDesignationTypeApi ?
                                    arr.map((value, index) => {
                                        return (

                                            <div className='d-flex justify-content-center align-items-center' style={{ height: "400px", width: "100%" }}>
                                            <BeatLoader />
                                        </div>
                                        )
                                    }) :
                                    spinnerLoader ?
                                        <>
                                            <div className='d-flex justify-content-center align-items-center' style={{ height: "400px", width: "100%" }}>
                                                <BeatLoader />
                                            </div>
                                        </> :
                                        <> */}
                            <div className="table-responsive custom-table">
                                <Table className="table datanew dataTable no-footer" pagination={false}
                                    dataSource={dataSource} columns={columns} />
                            </div>

                            <div className="row align-items-center">
                                {jobOrderListCCData?.length > 0 && <div className="pagination-controls my-5 d-flex justify-content-center align-items-center react-custom-paginate">
                                    <ReactPaginate
                                        previousLabel={<img src="/img/right.png" alt="Previous" />}
                                        nextLabel={<img src="/img/left.png" alt="Next" />}
                                        breakLabel="..."
                                        breakClassName="break-me"
                                        pageCount={totalPages}
                                        marginPagesDisplayed={2}
                                        pageRangeDisplayed={5}
                                        onPageChange={handlePageClick}
                                        containerClassName="pagination"
                                        activeClassName="active"
                                        forcePage={currentPage - 1}
                                    />
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <AddMaster show={addShow} handleClose={handleAddClose} onSuccess={handleSuccess} />
            <EditMaster show={editshow} handleClose={handleEditClose} onSuccess={handleSuccess} /> */}
            {/* <EditEmployee id="offcanvas_edit" />
            <AddEmployee id="offcanvas_add" /> */}
            {/* <CreateQuoteForm SentQuoteList={SentQuoteList} id="offcanvas_create" />
            <EditQuoteForm id="offcanvas_edit_form" QuotationId={id} ViewDetails={viewData} /> */}
        </>

    )
}

export default ExportJobList